import { render, staticRenderFns } from "./BulkEditAccounts.vue?vue&type=template&id=2dd6d283&"
import script from "./BulkEditAccounts.vue?vue&type=script&lang=js&"
export * from "./BulkEditAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports